export const UserManageRoutes = [
    {
        path: "/Admin/UserManage/OrganizationImport",
        name: "机构用户导入",
        component: () => import("./OrganizationImport/index.vue"),
        meta: {
            title: "机构用户导入",
        },
    },
    {
        path: "/Admin/UserManage/OrganizationList",
        name: "机构用户",
        component: () => import("./OrganizationList/index.vue"),
        meta: {
            title: "机构用户",
        },
    },
    {
        path: "/Admin/UserManage/UserImport",
        name: "个人用户导入",
        component: () => import("./UserImport/index.vue"),
        meta: {
            title: "个人用户导入",
        },
    },
    {
        path: "/Admin/UserManage/UserList",
        name: "个人用户",
        component: () => import("./UserList/index.vue"),
        meta: {
            title: "个人用户",
        },
    },
    {
        path: "/Admin/UserManage/OrganizationList/Edit",
        name: "新增机构",
        component: () => import("./OrganizationList/Edit.vue"),
        meta: {
            title: "个人用户",
        },
    },
    {
        path: "/Admin/UserManage/ExaminerList",
        name: "考官用户",
        component: () => import("./ExaminerList/index.vue"),
        meta: {
            title: "考官用户",
        },
    },
    {
        path: "/Admin/UserManage/ExaminerList/examinerDetail",
        name: "考官详情",
        component: () => import("./ExaminerList/examinerDetail.vue"),
        meta: {
            title: "考官详情",
        },
    },
    {
        path: "/Admin/UserManage/mipExamineeList",
        name: "考生用户",
        component: () => import("./mipExamineeList/index.vue"),
        meta: {
            title: "考生用户",
        },
    },
    {
        path: "/Admin/UserManage/mipExamineeList/examineeDetail",
        name: "考生详情",
        component: () => import("./mipExamineeList/examineeDetail.vue"),
        meta: {
            title: "考生详情",
        },
    },
]



// WEBPACK FOOTER //
// ./src/pages/Admin/AdminHome/UserManage/routes.js